<template>
  <Frontendlayout>
    <section class="hero_single version_2">
      <FilterType1new
        :loadNearbyOffers="loadNearbyOffers"
        :search="search"
        :categories="catOptions"
        :subcategories="subCatOptions"
      />
    </section>
    <!-- /hero_single -->
    <PopularTours />

    <PopularHotels />
    <!-- /container -->

    <PopularRestaurents />

    <div class="call_section">
      <div class="container clearfix">
        <div class="col-lg-5 col-md-6 float-right wow" data-wow-offset="250">
          <div class="block-reveal">
            <div class="block-vertical"></div>
            <div class="box_1">
              <h3>Enjoy a GREAT travel with us</h3>
              <p>
                Ius cu tamquam persequeris, eu veniam apeirian platonem qui, id
                aliquip voluptatibus pri. Ei mea primis ornatus disputationi.
                Menandri erroribus cu per, duo solet congue ut.
              </p>
              <a href="#0" class="btn_1 rounded">Read more</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/call_section-->
  </Frontendlayout>
</template>

<script>
//import API from "@/services/index";
import Frontendlayout from "@/layouts/Frontendlayout.vue";
import { EventBus } from "@/EventBus.js";
import FilterType1new from "@/cmps/FilterType1new.vue";
import PopularTours from "@/cmps/PopularTours.vue";
import PopularHotels from "@/cmps/PopularHotels.vue";
import PopularRestaurents from "@/cmps/PopularRestaurents.vue";
export default {
  created() {
    EventBus.$on("emittedData", (data) => {
      console.log("home pincode:" + data.search.pincode);
      this.catOptions = data.catList;
      this.subCatOptions = data.subCatList;
    });
  },
  data() {
    return {
      name: "Home",
      divId: "home",
      bodyId: "",

      search: {
        pincode: "",
        location: "",
        categories: [],
        subcategories: [],
        mindiscount: "",
        maxdiscount: "",
        discount_type: "percent",
        rating: "",
        range:0,
        geocodes:[]
      },
      catOptions: [],
      subCatOptions: [],
    };
  },
  beforeMount() {
    //this.loadNearbyOffers(this.search);
  },
  components: {
    Frontendlayout,
    FilterType1new,
    PopularTours,
    PopularHotels,
    PopularRestaurents,
  },
  methods: {
    loadNearbyOffers(filter) {
      localStorage.setItem("search", filter);
      this.$router.push({
        name: "FilterList2",
        params: { search: this.search },
      });
    },
  },
};
</script>


<style  scoped>
@import "../../public/frontend/css/custom.css";

#login_bg,
#register_bg {
  background: #fff !important;
}

.hero_single.version_2 .wrapper {
  background: transparent !important;
}
.hero_single.version_2 .wrapper p,
.hero_single.version_2 .wrapper h3 {
  color: #fff;
}

ul#top_menu li a.cart-menu-btn:before {
  color: #000;
}
.main-menu > ul > li span > a{
color: #f54149;
}
.hero_single.version_2 .wrapper {
  background-color: #fff;
}
.hero_single.version_2 {
  height: 550px;
  background: #33292991;
}
.margin_30_95 {
  padding-bottom: 0 !important;
}

/*============================================================================================*/
/* Your custom styles below */
/*============================================================================================*/
.select2-container--default.select2-container--focus
  .select2-selection--multiple {
  border: none;
}
.select2-container .select2-selection--multiple {
  min-height: 50px;
  border: 1px solid #d2d8dd;
}
.select2-container--default .select2-search--inline .select2-search__field {
  position: absolute;
  top: 8px;
}

.select2-container--default
  .select2-selection--multiple
  .select2-selection__choice {
  border: none;
  color: #fc5b62;
  background: #fff;
  border: solid #fc5b62 1px;
}
.select2-container--default
  .select2-selection--multiple
  .select2-selection__choice__remove {
  border: none;
  position: relative;
}
.select2-container--default
  .select2-selection--multiple
  .select2-selection__rendered {
  position: relative;
  top: 10px;
}
.select2-container--default
  .select2-selection--multiple
  .select2-selection__clear {
  font-size: 18px;
}
label {
  color: #7a777d;
  margin: 13px 0;
  position: relative;
  right: 28px;
  top: 1px;
}
.form-check-label {
  margin-bottom: 0;
  position: unset;
}
#flexRadioDefault1 {
  bottom: -13px;
}
.redio .form-group {
  border-right: 1px solid #d2d8dd;
}
.rdio {
  border-right: 1px solid #d2d8dd;
}
.label {
  text-align: left;
}
.label label {
  font-size: 16px;
  color: #000;
  position: relative;
  left: unset;
  right: unset;
}
</style>